import { TimelineData } from '@pages/reporting-pages/shipment-stops/types/TimelineData';
import { HoursArrayElement } from '@pages/reporting-pages/shipment-stops/types/HoursArrayElement';



interface TimelineProps {
	className: string,
	hoursArray: HoursArrayElement[],
	timelineData: TimelineData,
	stopNumber: number,
}
  

const TimelineRow = (props: TimelineProps) => {
	const { className, hoursArray, stopNumber } = props;
	const { showPlannedBlock, showRealBlock, plannedBlockMargin, plannedBlockLength, realBlockMargin, realBlockLength, minutesInDay, colorStatus } = props.timelineData;

	return (
		<div className={`${className} timeline-rows`}>
			{hoursArray && hoursArray.map((x,i) =>
				<div className='timeline-row-cell' key={`timeline-row-cell-${x.hourNumber}-${i}`}></div>)}

			{showPlannedBlock &&
				<div className='timeline-block timeline-planned-block' style={{
					left: `${plannedBlockMargin/minutesInDay}%`,
					width: `${plannedBlockLength/minutesInDay}%` }}>
						<p>{stopNumber && plannedBlockLength > 30 ? stopNumber : ''}</p>
				</div>}

			{showRealBlock &&
				<div className={`timeline-block timeline-real-block ${colorStatus}`} style={{
					left: `${realBlockMargin/minutesInDay}%`,
					width: `${realBlockLength/minutesInDay}%` }}>
						<p>{stopNumber && realBlockLength > 30 ? stopNumber : ''}</p>
				</div>}
		</div>
	)
}

export default TimelineRow;